import moment from 'moment-timezone'

export function storeLoginTime () {
  let loginTime = moment().tz('America/Chicago').format('YYYY-MM-DD HH:mm:ss')
  localStorage.setItem('loginTime', loginTime)
}
